<template>
    <svg id="age" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 13.207 13.207">
        <g id="Group_2746" data-name="Group 2746">
            <g id="Group_2745" data-name="Group 2745">
                <g id="Group_2744" data-name="Group 2744">
                    <path id="Path_70092" data-name="Path 70092"
                          d="M11.273,1.934a6.6,6.6,0,1,0-9.339,9.339,6.6,6.6,0,1,0,9.339-9.339ZM6.6,12.691A6.088,6.088,0,1,1,12.691,6.6,6.095,6.095,0,0,1,6.6,12.691Z"
                          fill="#799cfb"/>
                    <path id="Path_70093" data-name="Path 70093"
                          d="M444.4,246.217a.258.258,0,1,0-.154.288A.26.26,0,0,0,444.4,246.217Z"
                          transform="translate(-432.437 -239.663)" fill="#799cfb"/>
                    <path id="Path_70094" data-name="Path 70094"
                          d="M58.526,54.417a.258.258,0,0,0-.31.192,4.846,4.846,0,1,1,0-2.217.258.258,0,1,0,.5-.118,5.355,5.355,0,1,0,0,2.453.258.258,0,0,0-.192-.31Z"
                          transform="translate(-46.894 -46.895)" fill="#799cfb"/>
                    <path id="Path_70095" data-name="Path 70095"
                          d="M118.927,146.743a.8.8,0,0,0,.794-.794v-4.423a.8.8,0,0,0-.794-.794h-.945a.794.794,0,0,0,0,1.588h.152v3.629A.8.8,0,0,0,118.927,146.743Zm-.945-4.939a.278.278,0,0,1,0-.556h.945a.278.278,0,0,1,.278.278v4.423a.278.278,0,0,1-.556,0v-3.887a.258.258,0,0,0-.258-.258Z"
                          transform="translate(-114.165 -137.102)" fill="#799cfb"/>
                    <path id="Path_70096" data-name="Path 70096"
                          d="M236.154,144.245a2.072,2.072,0,0,0,1.525-3.476,1.726,1.726,0,1,0-3.05,0,2.072,2.072,0,0,0,1.525,3.476ZM235.127,141a.258.258,0,0,0,.04-.343,1.211,1.211,0,1,1,1.975,0,.258.258,0,0,0,.04.343,1.557,1.557,0,1,1-2.055,0Z"
                          transform="translate(-228.043 -134.668)" fill="#799cfb"/>
                    <path id="Path_70097" data-name="Path 70097"
                          d="M289.727,181.1a.655.655,0,1,0-.654-.654A.655.655,0,0,0,289.727,181.1Zm0-.793a.139.139,0,1,1-.139.139A.139.139,0,0,1,289.727,180.307Z"
                          transform="translate(-281.616 -175.153)" fill="#799cfb"/>
                    <path id="Path_70098" data-name="Path 70098"
                          d="M276.638,254.1a1,1,0,1,0-1-1A1,1,0,0,0,276.638,254.1Zm0-1.486a.485.485,0,1,1-.485.485A.486.486,0,0,1,276.638,252.61Z"
                          transform="translate(-268.527 -245.591)" fill="#799cfb"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IAge",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
